var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 29.5C40 34.4525 40 36.927 38.46 38.46C36.9235 40 34.4525 40 29.5 40C24.5475 40 22.073 40 20.54 38.46C19 36.9235 19 34.4525 19 29.5C19 24.5475 19 22.073 20.54 20.54C22.0765 19 24.5475 19 29.5 19C34.4525 19 36.927 19 38.46 20.54C40 22.0765 40 24.5475 40 29.5ZM40 29.5H50.5M71.5 40C66.5475 40 64.073 40 62.54 38.46C61 36.9235 61 34.4525 61 29.5C61 24.5475 61 22.073 62.54 20.54C64.0765 19 66.5475 19 71.5 19C76.4525 19 78.927 19 80.46 20.54C82 22.0765 82 24.5475 82 29.5C82 34.4525 82 36.927 80.46 38.46C78.9235 40 76.4525 40 71.5 40ZM71.5 40V50.5M61 71.5C61 66.5475 61 64.073 62.54 62.54C64.0765 61 66.5475 61 71.5 61C76.4525 61 78.927 61 80.46 62.54C82 64.0765 82 66.551 82 71.5C82 76.449 82 78.9235 80.46 80.46C78.9235 82 76.449 82 71.5 82C66.551 82 64.0765 82 62.54 80.46C61 78.9235 61 76.4525 61 71.5ZM61 71.5H50.5M29.5 61C34.4525 61 36.927 61 38.46 62.54C40 64.0765 40 66.5475 40 71.5C40 76.4525 40 78.927 38.46 80.46C36.9235 82 34.4525 82 29.5 82C24.5475 82 22.073 82 20.54 80.46C19 78.9235 19 76.4525 19 71.5C19 66.5475 19 64.073 20.54 62.54C22.0765 61 24.5475 61 29.5 61ZM29.5 61V50.5",
    stroke: "white",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlock);
export default __webpack_public_path__ + "static/media/block.cc8734d875aea09c7deefb52196c938b.svg";
export { ForwardRef as ReactComponent };